import {GetPermissionsUpgradePurchase} from "../../../subscriptions/SubscriptionService";

export async function getPremiumAccessFeatureData(accountId, filter) {
    let premiumAccessFeaturesResult;
    let premiumAccessFeaturesData = [];
    premiumAccessFeaturesResult = await GetPermissionsUpgradePurchase(filter);
    if (!premiumAccessFeaturesResult.error) {
        let upgrades;
        let downgrades;
        if (!premiumAccessFeaturesResult.result._embedded.initialPurchases.length > 0) {
            upgrades = premiumAccessFeaturesResult.result._embedded.upgrades;
            downgrades = premiumAccessFeaturesResult.result._embedded.downgrades
        } else {
            upgrades = premiumAccessFeaturesResult.result._embedded.initialPurchases;
            downgrades = [];
        }
        premiumAccessFeaturesData = [upgrades, downgrades];
    }
    return premiumAccessFeaturesData;
}